import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "card border-0 shadow-none rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4 p-xl-40" }
const _hoisted_4 = { class: "toolbar-card mb-4" }
const _hoisted_5 = { class: "toolbar-left" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "text-muted mb-0" }
const _hoisted_8 = { class: "toolbar-right" }
const _hoisted_9 = { class: "search-shell" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "stats-grid mb-4" }
const _hoisted_13 = { class: "stat-card" }
const _hoisted_14 = { class: "stat-label" }
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = { class: "stat-card" }
const _hoisted_17 = { class: "stat-label" }
const _hoisted_18 = { class: "stat-value text-success" }
const _hoisted_19 = { class: "stat-card" }
const _hoisted_20 = { class: "stat-label" }
const _hoisted_21 = { class: "stat-value text-danger" }
const _hoisted_22 = { class: "stat-card" }
const _hoisted_23 = { class: "stat-label" }
const _hoisted_24 = { class: "stat-value" }
const _hoisted_25 = {
  key: 0,
  class: "code-pill"
}
const _hoisted_26 = {
  key: 1,
  class: "table-name-cell"
}
const _hoisted_27 = {
  key: 2,
  class: "fw-semibold"
}
const _hoisted_28 = {
  key: 5,
  class: "d-flex justify-content-center gap-2"
}
const _hoisted_29 = ["title", "onClick"]
const _hoisted_30 = ["title", "onClick"]
const _hoisted_31 = {
  key: 0,
  class: "text-muted small fw-semibold"
}
const _hoisted_32 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_33 = { class: "modal-content border-0 shadow-lg rounded-4" }
const _hoisted_34 = { class: "modal-header border-bottom-dashed" }
const _hoisted_35 = { class: "modal-chip" }
const _hoisted_36 = { class: "modal-title fw-semibold mt-3 mb-1" }
const _hoisted_37 = { class: "text-muted mb-0 modal-copy" }
const _hoisted_38 = ["aria-label"]
const _hoisted_39 = { class: "modal-body p-4 p-xl-40" }
const _hoisted_40 = { class: "membership-card-tip-card mb-4" }
const _hoisted_41 = { class: "mb-1" }
const _hoisted_42 = { class: "mb-0 text-muted" }
const _hoisted_43 = { class: "row g-3" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "field-header" }
const _hoisted_46 = { class: "form-label fw-semibold mb-0" }
const _hoisted_47 = { class: "field-caption" }
const _hoisted_48 = { value: null }
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "field-header" }
const _hoisted_53 = { class: "form-label fw-semibold mb-0" }
const _hoisted_54 = { class: "field-caption" }
const _hoisted_55 = ["placeholder"]
const _hoisted_56 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "field-header" }
const _hoisted_59 = { class: "form-label fw-semibold mb-0" }
const _hoisted_60 = { class: "field-caption" }
const _hoisted_61 = { class: "reference-input-wrap" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = { class: "field-header" }
const _hoisted_67 = { class: "form-label fw-semibold mb-0" }
const _hoisted_68 = { class: "field-caption" }
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_71 = { class: "col-md-3" }
const _hoisted_72 = { class: "field-header" }
const _hoisted_73 = { class: "form-label fw-semibold mb-0" }
const _hoisted_74 = { class: "field-caption" }
const _hoisted_75 = { value: 1 }
const _hoisted_76 = { value: 0 }
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "field-header" }
const _hoisted_79 = { class: "form-label fw-semibold mb-0" }
const _hoisted_80 = { class: "field-caption" }
const _hoisted_81 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "field-header" }
const _hoisted_84 = { class: "form-label fw-semibold mb-0" }
const _hoisted_85 = { class: "field-caption" }
const _hoisted_86 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_87 = { class: "col-12" }
const _hoisted_88 = { class: "field-header" }
const _hoisted_89 = { class: "form-label fw-semibold mb-0" }
const _hoisted_90 = { class: "field-caption" }
const _hoisted_91 = ["placeholder"]
const _hoisted_92 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_93 = { class: "d-flex justify-content-between align-items-center mt-4 pt-2" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

import { computed, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { useI18n } from "vue-i18n";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import customerService, { type Customer } from "../../services/customer";
import membershipCardService, {
  type MembershipCard,
  type MembershipCardPayload,
} from "../../services/membershipCard";
import { hasPermission } from "../../utils/permission";

type ApiError = {
  response?: {
    status?: number;
    data?: {
      message?: string;
      errors?: Record<string, string[]>;
    };
  };
};

interface MembershipCardFormState {
  customer_id: number | null;
  card_name: string;
  card_number: string;
  balance: number;
  status: number;
  issued_at: string;
  expiry_date: string;
  note: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipCardPage',
  setup(__props) {

const cards = ref<MembershipCard[]>([]);
const customers = ref<Customer[]>([]);
const searchQuery = ref("");
const showModal = ref(false);
const selectedCard = ref<MembershipCard | null>(null);
const loading = ref(false);
const errors = ref<Record<string, string[]>>({});
const { t, locale } = useI18n();

const createDefaultForm = (): MembershipCardFormState => ({
  customer_id: null,
  card_name: "",
  card_number: "",
  balance: 0,
  status: 1,
  issued_at: "",
  expiry_date: "",
  note: "",
});

const form = ref<MembershipCardFormState>(createDefaultForm());
const canCreateMembershipCard = hasPermission("membership_card_create");
const canUpdateMembershipCard = hasPermission("membership_card_update");
const canDeleteMembershipCard = hasPermission("membership_card_delete");
const canSaveCurrentCard = computed(() =>
  selectedCard.value ? canUpdateMembershipCard : canCreateMembershipCard
);

const columns = computed(() => [
  { title: t("membership_card_page.table_card_number"), dataIndex: "card_number", key: "card_number", align: "center" as const, width: 180 },
  { title: t("membership_card_page.table_card_name"), dataIndex: "card_name", key: "card_name", align: "center" as const, width: 220 },
  { title: t("membership_card_page.table_customer"), dataIndex: "customer_name", key: "customer_name", align: "center" as const, width: 220 },
  { title: t("membership_card_page.table_balance"), dataIndex: "balance", key: "balance", align: "center" as const, width: 140 },
  { title: t("membership_card_page.table_issued"), dataIndex: "issued_at", key: "issued_at", align: "center" as const, width: 140 },
  { title: t("membership_card_page.table_expiry"), dataIndex: "expiry_date", key: "expiry_date", align: "center" as const, width: 140 },
  { title: t("membership_card_page.table_last_used"), dataIndex: "last_used_at", key: "last_used_at", align: "center" as const, width: 180 },
  { title: t("membership_card_page.table_status"), dataIndex: "status", key: "status", align: "center" as const, width: 140 },
  { title: t("membership_card_page.table_action"), key: "actions", align: "center" as const, width: 140 },
]);

const pageSizeOptions = ref(["10", "25", "50", "100", "1000"]);

const paginationConfig = computed(() => ({
  showSizeChanger: true,
  pageSizeOptions: pageSizeOptions.value,
  showTotal: (total: number, range: [number, number]) =>
    t("membership_card_page.pagination_total", {
      start: range[0],
      end: range[1],
      total,
    }),
  defaultPageSize: 10,
  locale: { items_per_page: t("membership_card_page.items_per_page") },
}));

const fetchInitialData = async () => {
  loading.value = true;
  try {
    const [cardResult, customerResult] = await Promise.allSettled([
      membershipCardService.getMembershipCards(),
      customerService.getCustomers(),
    ]);

    cards.value = cardResult.status === "fulfilled" ? cardResult.value : [];
    customers.value =
      customerResult.status === "fulfilled" ? customerResult.value : [];

    if (cardResult.status === "rejected") {
      throw cardResult.reason;
    }
  } catch (error) {
    await Swal.fire({
      icon: "error",
      title: t("membership_card_page.load_failed"),
      text: t("membership_card_page.load_failed_text"),
    });
  } finally {
    loading.value = false;
  }
};

const filteredCards = computed(() => {
  const query = searchQuery.value.trim().toLowerCase();
  if (!query) return cards.value;

  return cards.value.filter((card) =>
    [
      card.card_number,
      card.card_name,
      card.customer_name,
      card.customer?.name,
      card.note,
    ]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(query))
  );
});

const stats = computed(() => {
  const total = cards.value.length;
  const active = cards.value.filter((card) => isActive(card.status)).length;
  const balance = cards.value.reduce(
    (sum, card) => sum + Number(card.balance || 0),
    0
  );

  return {
    total,
    active,
    inactive: Math.max(total - active, 0),
    balance,
  };
});

watch(
  filteredCards,
  (newValue) => {
    const totalCount = newValue.length > 0 ? newValue.length : 1000;
    pageSizeOptions.value = ["10", "25", "50", "100", String(totalCount)];
  },
  { immediate: true }
);

const isActive = (status?: number | boolean) =>
  String(status ?? 1) !== "0" && String(status ?? 1) !== "false";

const formatMoney = (value?: number | string) =>
  `$${Number(value || 0).toFixed(2)}`;

const formatDate = (value?: string | null) => {
  if (!value) return t("membership_card_page.not_available");

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return t("membership_card_page.not_available");

  const hasTime = /T|\d{2}:\d{2}/.test(value);
  const localeCode = String(locale.value).startsWith("km") ? "km-KH" : "en-GB";
  return hasTime
    ? date.toLocaleString(localeCode, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : date.toLocaleDateString(localeCode);
};

const resetForm = () => {
  form.value = createDefaultForm();
  errors.value = {};
};

const openCreateModal = () => {
  if (!canCreateMembershipCard) {
    Swal.fire({
      icon: "warning",
      title: t("membership_card_page.permission_required"),
      text: t("membership_card_page.create_permission_text"),
    });
    return;
  }

  selectedCard.value = null;
  resetForm();
  generateCardNumber();
  showModal.value = true;
};

const openEditModal = (card: MembershipCard) => {
  if (!canUpdateMembershipCard) {
    Swal.fire({
      icon: "warning",
      title: t("membership_card_page.permission_required"),
      text: t("membership_card_page.edit_permission_text"),
    });
    return;
  }

  selectedCard.value = card;
  errors.value = {};
  form.value = {
    customer_id: card.customer_id ? Number(card.customer_id) : null,
    card_name: card.card_name || "",
    card_number: card.card_number || "",
    balance: Number(card.balance || 0),
    status: Number(card.status ?? 1),
    issued_at: card.issued_at || "",
    expiry_date: card.expiry_date || "",
    note: card.note || "",
  };
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  errors.value = {};
};

const generateCardNumber = () => {
  const nextNumber =
    cards.value
      .map((item) => {
        const match = String(item.card_number || "").match(/(\d+)\s*$/);
        return match ? Number(match[1]) : 0;
      })
      .reduce((max, current) => Math.max(max, current), 0) + 1;

  form.value.card_number = `CARD${String(nextNumber).padStart(3, "0")}`;
};

const saveCard = async () => {
  if (!canSaveCurrentCard.value) {
    await Swal.fire({
      icon: "warning",
      title: t("membership_card_page.permission_required"),
      text: selectedCard.value
        ? t("membership_card_page.update_permission_text")
        : t("membership_card_page.create_permission_text"),
    });
    return;
  }

  loading.value = true;
  errors.value = {};

  try {
    const payload: MembershipCardPayload = {
      customer_id:
        form.value.customer_id !== null &&
        form.value.customer_id !== undefined &&
        Number(form.value.customer_id || 0) > 0
          ? Number(form.value.customer_id)
          : null,
      card_name: form.value.card_name.trim(),
      card_number: form.value.card_number.trim().toUpperCase(),
      balance: Math.max(0, Number(form.value.balance || 0)),
      status: Number(form.value.status ?? 1),
      issued_at: form.value.issued_at || null,
      expiry_date: form.value.expiry_date || null,
      note: form.value.note.trim() || null,
    };

    if (selectedCard.value?.id) {
      await membershipCardService.updateMembershipCard(selectedCard.value.id, payload);
    } else {
      await membershipCardService.createMembershipCard(payload);
    }

    await fetchInitialData();
    await Swal.fire({
      icon: "success",
      title: selectedCard.value ? t("membership_card_page.updated_title") : t("membership_card_page.created_title"),
      timer: 1400,
      showConfirmButton: false,
    });
    closeModal();
  } catch (error: unknown) {
    const apiError = error as ApiError;
    if (apiError.response?.status === 422) {
      errors.value = apiError.response.data?.errors || {};
    } else {
      await Swal.fire({
        icon: "error",
        title: t("membership_card_page.save_failed"),
        text:
          apiError.response?.data?.message ||
          t("membership_card_page.save_failed_text"),
      });
    }
  } finally {
    loading.value = false;
  }
};

const deleteCard = async (card: MembershipCard) => {
  if (!card.id) return;

  if (!canDeleteMembershipCard) {
    await Swal.fire({
      icon: "warning",
      title: t("membership_card_page.permission_required"),
      text: t("membership_card_page.delete_permission_text"),
    });
    return;
  }

  const result = await Swal.fire({
    title: t("membership_card_page.delete_title"),
    text: t("membership_card_page.delete_text", { name: card.card_name }),
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: t("membership_card_page.delete_confirm"),
    cancelButtonText: t("common.cancel"),
    reverseButtons: true,
  });

  if (!result.isConfirmed) return;

  try {
    Swal.fire({
      title: t("membership_card_page.deleting_title"),
      text: t("membership_card_page.deleting_text"),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await membershipCardService.deleteMembershipCard(card.id);
    await fetchInitialData();

    await Swal.fire({
      icon: "success",
      title: t("membership_card_page.deleted_title"),
      text: t("membership_card_page.deleted_text", { name: card.card_name }),
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (error: unknown) {
    const apiError = error as ApiError;
    await Swal.fire({
      icon: "error",
      title: t("membership_card_page.delete_failed"),
      text:
        apiError.response?.data?.message ||
        t("membership_card_page.delete_failed_text"),
    });
  }
};

onMounted(fetchInitialData);

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "membership_card_page.list_title" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t("membership_card_page.list_title")), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("membership_card_page.list_description")), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                  type: "text",
                  class: "form-control toolbar-search",
                  placeholder: _ctx.$t('membership_card_page.search_placeholder')
                }, null, 8, _hoisted_10), [
                  [_vModelText, searchQuery.value]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "ri-search-line search-icon" }, null, -1))
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "btn style-one btn-sm d-flex align-items-center gap-2",
                disabled: loading.value,
                onClick: openCreateModal
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "ri-bank-card-line" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("membership_card_page.create_button")), 1)
              ], 8, _hoisted_11)), [
                [_directive_permission, 'membership_card_create']
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("membership_card_page.total_cards")), 1),
              _createElementVNode("strong", _hoisted_15, _toDisplayString(stats.value.total), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("membership_card_page.active_cards")), 1),
              _createElementVNode("strong", _hoisted_18, _toDisplayString(stats.value.active), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("membership_card_page.inactive_cards")), 1),
              _createElementVNode("strong", _hoisted_21, _toDisplayString(stats.value.inactive), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("membership_card_page.stored_balance")), 1),
              _createElementVNode("strong", _hoisted_24, _toDisplayString(formatMoney(stats.value.balance)), 1)
            ])
          ]),
          _createVNode(_component_a_table, {
            columns: columns.value,
            "data-source": filteredCards.value,
            "row-key": 'id',
            pagination: paginationConfig.value,
            loading: loading.value,
            locale: { emptyText: _ctx.$t('membership_card_page.no_cards_found') },
            class: "membership-card-table"
          }, {
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.key === 'card_number')
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(text || _ctx.$t("membership_card_page.not_available")), 1))
                : (column.key === 'customer_name')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("strong", null, _toDisplayString(record.customer_name || record.customer?.name || _ctx.$t("membership_card_page.general_customer")), 1)
                    ]))
                  : (column.key === 'balance')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(formatMoney(record.balance)), 1))
                    : (column.key === 'status')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: _normalizeClass(["status-badge", isActive(record.status) ? 'status-active' : 'status-inactive'])
                        }, _toDisplayString(isActive(record.status) ? _ctx.$t("membership_card_page.status_active") : _ctx.$t("membership_card_page.status_inactive")), 3))
                      : (column.key === 'issued_at' || column.key === 'expiry_date' || column.key === 'last_used_at')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createTextVNode(_toDisplayString(formatDate(text)), 1)
                          ], 64))
                        : (column.key === 'actions')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _withDirectives((_openBlock(), _createElementBlock("button", {
                                class: "icon-btn",
                                title: _ctx.$t('membership_card_page.edit'),
                                onClick: ($event: any) => (openEditModal(record))
                              }, [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("i", { class: "ri-pencil-line" }, null, -1)
                              ]))], 8, _hoisted_29)), [
                                [_directive_permission, 'membership_card_update']
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("button", {
                                class: "icon-btn danger",
                                title: _ctx.$t('membership_card_page.delete'),
                                onClick: ($event: any) => (deleteCard(record))
                              }, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("i", { class: "ri-delete-bin-6-line" }, null, -1)
                              ]))], 8, _hoisted_30)), [
                                [_directive_permission, 'membership_card_delete']
                              ]),
                              (!_unref(canUpdateMembershipCard) && !_unref(canDeleteMembershipCard))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t("membership_card_page.view_only")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              _createTextVNode(_toDisplayString(text || _ctx.$t("membership_card_page.not_available")), 1)
                            ], 64))
            ]),
            _: 1
          }, 8, ["columns", "data-source", "pagination", "loading", "locale"])
        ])
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter)
    ]),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal fade show d-block membership-card-modal",
          tabindex: "-1",
          "aria-modal": "true",
          role: "dialog",
          onClick: _withModifiers(closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(selectedCard.value ? _ctx.$t("membership_card_page.edit_chip") : _ctx.$t("membership_card_page.new_chip")), 1),
                  _createElementVNode("h5", _hoisted_36, _toDisplayString(selectedCard.value ? _ctx.$t("membership_card_page.update_title") : _ctx.$t("membership_card_page.create_title")), 1),
                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("membership_card_page.modal_description")), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close shadow-none",
                  "aria-label": _ctx.$t('common.close'),
                  onClick: closeModal
                }, null, 8, _hoisted_38)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tip-icon" }, [
                    _createElementVNode("i", { class: "ri-bank-card-line" })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", _hoisted_41, _toDisplayString(selectedCard.value ? _ctx.$t("membership_card_page.edit_tip_title") : _ctx.$t("membership_card_page.create_tip_title")), 1),
                    _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t("membership_card_page.tip_description")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("membership_card_page.customer")), 1),
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("membership_card_page.customer_caption")), 1)
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customer_id) = $event)),
                      class: _normalizeClass(["form-select modal-input", { 'is-invalid': errors.value.customer_id }])
                    }, [
                      _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t("membership_card_page.general_customer")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customers.value, (customer) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: customer.id,
                          value: Number(customer.id)
                        }, _toDisplayString(customer.name), 9, _hoisted_49))
                      }), 128))
                    ], 2), [
                      [_vModelSelect, form.value.customer_id]
                    ]),
                    (errors.value.customer_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(errors.value.customer_id[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("membership_card_page.card_name")), 1),
                      _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("membership_card_page.card_name_caption")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.card_name) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control modal-input", { 'is-invalid': errors.value.card_name }]),
                      placeholder: _ctx.$t('membership_card_page.card_name_placeholder')
                    }, null, 10, _hoisted_55), [
                      [_vModelText, form.value.card_name]
                    ]),
                    (errors.value.card_name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(errors.value.card_name[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("membership_card_page.card_number")), 1),
                      _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("membership_card_page.card_number_caption")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.card_number) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control modal-input", { 'is-invalid': errors.value.card_number }]),
                        placeholder: _ctx.$t('membership_card_page.card_number_placeholder'),
                        onInput: _cache[4] || (_cache[4] = ($event: any) => (form.value.card_number = String(form.value.card_number || '').toUpperCase()))
                      }, null, 42, _hoisted_62), [
                        [_vModelText, form.value.card_number]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light generate-code-btn",
                        disabled: loading.value,
                        onClick: generateCardNumber
                      }, [
                        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("membership_card_page.generate_code")), 1)
                      ], 8, _hoisted_63)
                    ]),
                    (errors.value.card_number)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(errors.value.card_number[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("membership_card_page.balance")), 1),
                      _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("membership_card_page.balance_caption")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.balance) = $event)),
                      type: "number",
                      min: "0",
                      step: "0.01",
                      class: _normalizeClass(["form-control modal-input", { 'is-invalid': errors.value.balance }]),
                      placeholder: _ctx.$t('membership_card_page.balance_placeholder')
                    }, null, 10, _hoisted_69), [
                      [
                        _vModelText,
                        form.value.balance,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    (errors.value.balance)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(errors.value.balance[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("membership_card_page.status")), 1),
                      _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t("membership_card_page.status_caption")), 1)
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.status) = $event)),
                      class: "form-select modal-input"
                    }, [
                      _createElementVNode("option", _hoisted_75, _toDisplayString(_ctx.$t("membership_card_page.status_active")), 1),
                      _createElementVNode("option", _hoisted_76, _toDisplayString(_ctx.$t("membership_card_page.status_inactive")), 1)
                    ], 512), [
                      [
                        _vModelSelect,
                        form.value.status,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t("membership_card_page.issued_date")), 1),
                      _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t("membership_card_page.issued_date_caption")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.issued_at) = $event)),
                      type: "date",
                      class: _normalizeClass(["form-control modal-input", { 'is-invalid': errors.value.issued_at }])
                    }, null, 2), [
                      [_vModelText, form.value.issued_at]
                    ]),
                    (errors.value.issued_at)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(errors.value.issued_at[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("membership_card_page.expiry_date")), 1),
                      _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t("membership_card_page.expiry_date_caption")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.expiry_date) = $event)),
                      type: "date",
                      class: _normalizeClass(["form-control modal-input", { 'is-invalid': errors.value.expiry_date }])
                    }, null, 2), [
                      [_vModelText, form.value.expiry_date]
                    ]),
                    (errors.value.expiry_date)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(errors.value.expiry_date[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("membership_card_page.note")), 1),
                      _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.$t("membership_card_page.note_caption")), 1)
                    ]),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.note) = $event)),
                      rows: "4",
                      class: _normalizeClass(["form-control modal-input modal-textarea", { 'is-invalid': errors.value.note }]),
                      placeholder: _ctx.$t('membership_card_page.note_placeholder')
                    }, null, 10, _hoisted_91), [
                      [_vModelText, form.value.note]
                    ]),
                    (errors.value.note)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(errors.value.note[0]), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light px-4",
                    onClick: closeModal
                  }, _toDisplayString(_ctx.$t("common.cancel")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn style-one px-4 h-55",
                    disabled: loading.value || !canSaveCurrentCard.value,
                    onClick: saveCard
                  }, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_95))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(loading.value ? _ctx.$t("membership_card_page.saving") : selectedCard.value ? _ctx.$t("membership_card_page.update_action") : _ctx.$t("membership_card_page.create_action")), 1)
                  ], 8, _hoisted_94)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})